'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "title", "tooltip"];
import styled from 'styled-components';
import { WEB_FONT_DEMI_BOLD_WEIGHT } from 'HubStyleTokens/misc';
import UIAccordionItem from 'UIComponents/accordion/UIAccordionItem';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledUIAccordionItem = styled(UIAccordionItem).withConfig({
  displayName: "SidebarSection__StyledUIAccordionItem",
  componentId: "ab5di5-0"
})([".sidebar-section__title{font-weight:", ";}"], WEB_FONT_DEMI_BOLD_WEIGHT);
const SidebarSection = _ref => {
  let {
      children,
      title,
      tooltip = ''
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(StyledUIAccordionItem, Object.assign({}, rest, {
    className: "m-bottom-4",
    title: /*#__PURE__*/_jsx(UITooltip, {
      delay: 200,
      disabled: !tooltip,
      placement: "right",
      title: tooltip,
      children: /*#__PURE__*/_jsx("span", {
        children: title
      })
    }),
    titleClassName: "sidebar-section__title m-y-0",
    children: /*#__PURE__*/_jsx("div", {
      className: "p-top-0",
      children: children
    })
  }));
};
export default SidebarSection;